import { appApi } from 'dux/app/api';

import type { CouponCustomersStatusResponse } from './types';

const couponCustomersApiSlice = appApi.injectEndpoints({
  endpoints: (build) => ({
    getCouponCustomersStatus: build.query<CouponCustomersStatusResponse, void>({
      query: () => ({
        url: `v1/coupon_customers/status/`,
        endpointName: 'couponCustomersStatusQuery',
        method: 'POST',
        json: { coupons: ['sub_supplements_free_first_order'] },
      }),
      providesTags: ['couponCustomers'],

      keepUnusedDataFor: 0, // no caching for now
    }),
  }),
});

export const { useGetCouponCustomersStatusQuery } = couponCustomersApiSlice;
